import { Link } from 'react-router-dom';
import { ArrowLeft, Compass } from 'lucide-react';
import { Button } from '@/components/ui/Button';

export default function NotFound() {
  return (
    <div className="grid min-h-[70vh] place-items-center px-4">
      <div className="card flex max-w-md flex-col items-center gap-5 p-10 text-center">
        <div className="grid h-14 w-14 place-items-center rounded-2xl bg-brand-50 text-brand-700">
          <Compass className="h-6 w-6" />
        </div>
        <div className="flex flex-col gap-2">
          <div className="text-[0.75rem] font-semibold uppercase tracking-kicker text-ink-dim">
            Error 404
          </div>
          <h1 className="text-[2.5rem] font-bold leading-none tracking-head text-ink">
            Page not found
          </h1>
          <p className="text-sm leading-relaxed text-ink-muted">
            That record has been misfiled, or never existed in the first place.
          </p>
        </div>
        <Button asChild>
          <Link to="/">
            <ArrowLeft className="h-4 w-4" /> Return to dashboard
          </Link>
        </Button>
      </div>
    </div>
  );
}
